import api from "@/services/api";
import { processAuthResponse } from "@/services/processAuthResponse";

export async function finishSocialTalentSession(
  store,
  router,
  updateCurrentStep,
  {
    token,
    created_account = false,
    application_id = null,
    vacancy_id,
    company_label,
    company,
    utm_source,
    dashboardRouteName,
  }
) {
  localStorage.setItem("userToken", token);
  store.dispatch("auth/addToken", { token });
  if (utm_source !== undefined && utm_source !== null) {
    sessionStorage.setItem("utm_source", utm_source);
  }

  const { data } = await api.get("/api/v2/auth/");
  const user = data.data && data.data.user;
  const authMeta = data.data && data.data.auth;

  if (user && user.active === 0) {
    throw new Error("Sua conta está desativada. Entre em contato com o suporte para mais informações.");
  }
  if (company && company.active === 0) {
    throw new Error(
      'Esta empresa não está mais ativa na Recrutei. Acesse sua conta por <a href="https://talent.recrutei.com.br/recrutei-empregos/signin">aqui</a>.'
    );
  }

  if (user) {
    processAuthResponse(store, {
      token,
      user,
      authMeta,
      talent: user.talent,
      company,
      application_id,
      created_account,
      channel: utm_source && utm_source !== "" ? utm_source : undefined,
      vacancy_id,
      company_label,
    });
  }

  const nextName = created_account
    ? "step-basic-info"
    : dashboardRouteName ||
      (vacancy_id ? "step-basic-info" : "dashboard-vacancy");

  await router.push({
    name: nextName,
    params: { vacancy_id, company_label },
  });
  await updateCurrentStep({ order: 0 });
}
